import api from '@functions/api'

const searchEndpoint = (string, requestOptions, requestUrl) => {
  if (!requestUrl) return { success: false }

  const mergedOptions = {
    string,
    ...requestOptions,
  }

  return api(requestUrl, mergedOptions)
    .then(({ data }) => ({ success: true, data }))
    .catch(errors => ({ success: false, errors }))
}

export default searchEndpoint
